module.exports = __webpack_public_path__ + "static/media/code2.de3aa75b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/code2.jpg
// module id = 253
// module chunks = 0